export * from './herausgebers-list.component';
export * from './herausgebers-list.component.module';